import { boot } from 'quasar/wrappers'
import { createI18n, useConfig, useI18n, useLink, useRouter } from 'booksprout-app'
import { bsConstants } from 'booksprout'

/**
 * Initialises the DI-free infrastructure modules — the work `modules/_base/container.ts` did
 * for ConfigService / TranslationService / LinkService, plus the router, which had no service.
 *
 * Listed first in quasar.conf.js so it runs before the boot files that use these: `axios` and
 * `routeGuard` both reach the API, and error handling translates through i18n.
 *
 * The i18n instance is created here rather than at module scope in the sibling `i18n` boot file,
 * because a boot file's body runs once per request while its module scope runs once per process.
 * The reader can pick a language now, so a shared instance would render one reader's page in
 * another's language — see i18nModule. The sibling boot file reads it back through `useI18n()`
 * and hands it to Vue.
 *
 * It used to inject three handlers so apolloModule and authenticationService could reach the Vuex
 * `ui` module — for the 403/404/offline redirects, permission errors and the login prompt. `ui` is a
 * composable module now, so they call `useUi()` directly and the seams are gone.
 */
export default boot(({ router }) => {
  useConfig().initFromEnv()
  useI18n().init(createI18n())
  useLink().init(bsConstants.APP.HOME_URLS.WEBSITE)
  // Client-only by design; see routingModule.init().
  useRouter().init(router)
})
